import React from "react";
import "../../style/main.scss";
import "../../style/shared/_navbar.scss";
import { useState , useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useNavigate, useLocation, NavLink} from "react-router-dom";
const Navbar = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();

  const handleNavigation = (link) => {
    if (link === "/#feature") {
      // Scroll to the roadmap section
      const featureSection = document.getElementById("feature");
      if (featureSection) {
        featureSection.scrollIntoView({ behavior: "smooth" });
      }
    } else if (link === "/#team") {
      // Scroll to the team section
      const teamSection = document.getElementById("team");
      if (teamSection) {
        teamSection.scrollIntoView({ behavior: "smooth" });
      }
    }
    else if (link === "/#contact") {
      // Scroll to the roadmap section
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    } 
    else {
      // Navigate to other links
      navigate(link);
    }
    setShow(false);
  };

  const location = useLocation();
  const id = location.hash.split("#");
  useEffect(() => {
    if (id) {
      const element = document.getElementById(id[1]);
      if (element) {
        element.scrollIntoView({
          block: "nearest",
          alignToTop: true,
          behavior: "smooth",
        });
      }
    }
  }, [id]);
  return (
    // <div>
    //   <nav class="navbar navbar-expand-lg bg-body-tertiary">
    //     <div class="container-fluid">
    //       <a class="navbar-brand" href="#">
    //         Navbar
    //       </a>
    //       <button
    //         class="navbar-toggler"
    //         type="button"
    //         data-bs-toggle="collapse"
    //         data-bs-target="#navbarSupportedContent"
    //         aria-controls="navbarSupportedContent"
    //         aria-expanded="false"
    //         aria-label="Toggle navigation"
    //       >
    //         <span class="navbar-toggler-icon"></span>
    //       </button>
    //       <div class="collapse navbar-collapse" id="navbarSupportedContent">
    //         <ul class="navbar-nav me-auto mb-2 mb-lg-0">
    //           <li class="nav-item">
    //             <a class="nav-link active" aria-current="page" href="#">
    //               Home
    //             </a>
    //           </li>
    //           <li class="nav-item">
    //             <a class="nav-link" href="#">
    //               Link
    //             </a>
    //           </li>
    //           <li class="nav-item dropdown">
    //             <a
    //               class="nav-link dropdown-toggle"
    //               href="#"
    //               role="button"
    //               data-bs-toggle="dropdown"
    //               aria-expanded="false"
    //             >
    //               Dropdown
    //             </a>
    //             <ul class="dropdown-menu">
    //               <li>
    //                 <a class="dropdown-item" href="#">
    //                   Action
    //                 </a>
    //               </li>
    //               <li>
    //                 <a class="dropdown-item" href="#">
    //                   Another action
    //                 </a>
    //               </li>
    //               <li>
    //                 <hr class="dropdown-divider" />
    //               </li>
    //               <li>
    //                 <a class="dropdown-item" href="#">
    //                   Something else here
    //                 </a>
    //               </li>
    //             </ul>
    //           </li>
    //           <li class="nav-item">
    //             <a class="nav-link disabled" aria-disabled="true">
    //               Disabled
    //             </a>
    //           </li>
    //         </ul>
    //         <form class="d-flex" role="search">
    //           <input
    //             class="form-control me-2"
    //             type="search"
    //             placeholder="Search"
    //             aria-label="Search"
    //           />
    //           <button class="btn btn-outline-success" type="submit">
    //             Search
    //           </button>
    //         </form>
    //       </div>
    //     </div>
    //   </nav>
    // </div>
    <>
      <div className="navbarWrapper">
        <nav className="navbarContent">
          <div className="Logo">
            <img
              src="../../../images/home/logo-removebg-preview.png"
              alt="..."
            />
          </div>
          <ul class="navbar-nav">
            <li class="nav-item">
              <Link class="nav-link" to="/">
                Home
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="/#feature">
                Feature
              </Link>
            </li>

            <li class="nav-item">
              <Link class="nav-link" to="/#team">
                Team
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="/accomplish">
                Accomplishments
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="/#contact">
                Contact Us{" "}
              </Link>
            </li>
          </ul>

          <div className="navbarRightContent">
            <button
              className="login-btn text-white"
              onClick={() => navigate("/login")}
            >
              Log In
            </button>
            <button className="signup-btn" onClick={() => navigate("/signup")}>
              Sign Up
            </button>
          </div>
        </nav>
      </div>

      {/* <div className="mobile-navbar">
      <Button variant="primary" className="d-lg-none" onClick={handleShow}>
        Launch
      </Button>

      <Alert variant="info" className="d-none d-lg-block">
        Resize your browser to show the responsive offcanvas toggle.
      </Alert>

      <Offcanvas show={show} onHide={handleClose} responsive="lg">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Responsive offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="mb-0">
            This is content within an <code>.offcanvas-lg</code>.
          </p>
        </Offcanvas.Body>
      </Offcanvas>
    </div> */}
      <div className="mobile-navbar">
        <img
          src="/images/home/logo-removebg-preview.png"
          alt="..."
          className="logostyle "
        />
        <Button onClick={handleShow} className="menu-btn">
          <img src="../../../images/home/icons8-menu-50.png" />
        </Button>

        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img
                src="../../../images/home/logo-removebg-preview.png"
                alt=""
                className="logostyle"
              />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul>
              <li>
                <a onClick={() => handleNavigation("/")}>Home</a>
              </li>
              <li>
                <a href="#FeatureSection">Feature</a>
              </li>
              <li>
                <a href="#team">Team</a>
              </li>

              <li>
                <a onClick={() => handleNavigation("/accomplish")}>Accomplishment</a>
              </li>

              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
            <div className="navbarRightContent">
            <button
              className="login-btn text-white"
              onClick={() => navigate("/login")}
            >
              Log In
            </button>
            <button className="signup-btn" onClick={() => navigate("/signup")}>
              Sign Up
            </button>
          </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Navbar;
